import { render, staticRenderFns } from "./add-vessel-location-modal.vue?vue&type=template&id=2d6738d6&scoped=true"
import script from "./add-vessel-location-modal.vue?vue&type=script&lang=js"
export * from "./add-vessel-location-modal.vue?vue&type=script&lang=js"
import style0 from "./add-vessel-location-modal.vue?vue&type=style&index=0&id=2d6738d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6738d6",
  null
  
)

export default component.exports